module.exports = __webpack_public_path__ + "32328d6d130a8b388707a5bb92494dcf.mp3";